module.exports = __webpack_public_path__ + "img/witch_blade.7bfeb049.png";